import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_8 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_9 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Consultar CEP nos correios", -1)
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_endereco = _resolveComponent("selecionar-tipo-endereco")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_cidade = _resolveComponent("selecionar-cidade")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: 800,
      title: "Endereço",
      "wrap-class-name": "ss-modal-cadastros",
      centered: ""
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvarEndereco && _ctx.salvarEndereco(...args)))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Tipo",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_tipo_endereco, {
                      relacoes: _ctx.props.relacoes,
                      codigoSelecionado: _ctx.state.pessoaEndereco.tipoEndereco,
                      "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pessoaEndereco.tipoEndereco) = $event))
                    }, null, 8, ["relacoes", "codigoSelecionado"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, {
                  label: "Identificação",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "250",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pessoaEndereco.identificacao) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaEndereco.identificacao]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form_item, {
                  label: "CEP",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_campo_cep, {
                        valor: _ctx.state.pessoaEndereco.endereco.cep,
                        "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pessoaEndereco.endereco.cep) = $event)),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.consultaCEP($event.target.value)))
                      }, null, 8, ["valor"]),
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                          title: _withCtx(() => [
                            _hoisted_10
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.consultaCEP(_ctx.state.pessoaEndereco.endereco.cep)))
                            }, [
                              _createVNode(_component_icone, { nome: "cep" })
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_form_item, {
                  label: "Endereço/Avenida/Rua",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.pessoaEndereco.endereco.logradouro) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaEndereco.endereco.logradouro]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_form_item, {
                  label: "Número",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "10",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pessoaEndereco.endereco.numero) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaEndereco.endereco.numero]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_a_form_item, {
                  label: "Complemento",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.pessoaEndereco.endereco.complemento) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaEndereco.endereco.complemento]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_form_item, {
                  label: "Bairro",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.pessoaEndereco.endereco.bairro) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaEndereco.endereco.bairro]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_form_item, {
                  label: "Cidade/Estado",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_cidade, {
                      codigoSelecionado: _ctx.state.pessoaEndereco.endereco.codigoCidade,
                      "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.pessoaEndereco.endereco.codigoCidade) = $event)),
                      apresentarEstado: true
                    }, null, 8, ["codigoSelecionado"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_requisicao_modal, {
              visivel: _ctx.modalBase.exibirRequisicaoModal,
              "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
              retornoRequisicao: _ctx.modalBase.retornoRequisicao
            }, null, 8, ["visivel", "retornoRequisicao"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}